module.exports = {
  encode: require('./dist/plantuml-encoder').encode,
  decode: require('./dist/plantuml-decoder').decode
}



//////////////////
// WEBPACK FOOTER
// ./~/plantuml-encoder/browser-index.js
// module id = 458
// module chunks = 1